import React, { useState } from "react";
import Button from "web/components/Button";
import DropDown from "web/components/DropDown";
import styled from "styled-components";
import DatePicker from "web/components/DatePicker";
import * as moment from "moment";
import { BIDFORMAT } from "web/components/utils/dateOfBirthValidation";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";

export default ({ isOpen, toggle, callBackFun }) => {
  let toDate = new Date();
  let fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - 31);
  toDate.setDate(fromDate.getDate() + 31);
  const [requestedFromDate, setRequestedFromDate] = useState(
    fromDate.toISOString().substr(0, 10)
  );
  const [requestedToDate, setRequestedToDate] = useState(
    toDate.toISOString().substr(0, 10)
  );

  const INITIAL_VALUES = {
    bidStatus: "ALL",
    deliveryReq: "ALL",
    fromDate: fromDate.toISOString().substr(0, 10),
    toDate: toDate.toISOString().substr(0, 10),
  };

  const VALIDATION_SCHEMA = Yup.object().shape({});

  const [bidStatuses, setBidStatuses] = useState([
    { label: "All", value: "ALL" },
    { label: "Bid Placed", value: "PENDING" },
    { label: "Bid Accepted", value: "ACCEPTED" },
    { label: "Bid Declined", value: "REJECTED" },
    { label: "Bid Withdrawn", value: "WITHDRAW" },
  ]);

  const [deliveryRequirements, setDeliveryRequirements] = useState([
    { label: "All", value: "ALL" },
    { label: "Pick Up", value: "PICKUP" },
    { label: "Delivery", value: "DELIVERY" },
  ]);

  return (
    <div className="alert-modal">
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={(values) => {}}
      >
        {(props) => {
          const {
            isValid,
            dirty,
            values,
            errors,
            touched,
            setFieldValue,
            resetForm,
          } = props;

          return (
            <>
              <Form>
                <Modal isOpen={isOpen} centered={true} size="md">
                  <ModalHeader toggle={() => toggle()}>
                    <h6>Filter by </h6>
                  </ModalHeader>
                  <ModalBody>
                    <DropDownWrapper>
                      <div className="dropDown">
                        <label>Bid Status</label>
                        <DropDown
                          name="bidStatus"
                          data={bidStatuses}
                          placeholder=""
                          searchDropDown={props.values.bidStatus}
                          onChangeHandler={(event) => {
                            setFieldValue("bidStatus", event.value);
                          }}
                        />
                      </div>

                      <div className="dropDown">
                        <label>Delivery Requirements</label>
                        <DropDown
                          name="deliveryReq"
                          data={deliveryRequirements}
                          placeholder=""
                          searchDropDown={props.values.deliveryReq}
                          onChangeHandler={(event) => {
                            setFieldValue("deliveryReq", event.value);
                          }}
                        />
                      </div>
                    </DropDownWrapper>
                    <SelectWrapper>
                      <label>Requested Date</label>
                      <div>
                      <DatePicker name="fromDate" maxDate={requestedToDate} value={requestedFromDate} callBackFun={(date)=>{
                             setRequestedFromDate(moment(date).format(BIDFORMAT));
                             setFieldValue("fromDate", moment(date).format(BIDFORMAT));
                          }}/>
                         
                          <p style={{'margin-top': '5px'}}>To</p>
                          <DatePicker name="toDate" minDate={requestedFromDate} value={requestedToDate} callBackFun={(date)=>{
                             setRequestedToDate(moment(date).format(BIDFORMAT));
                             setFieldValue("toDate", moment(date).format(BIDFORMAT));
                          }}/>
                        {/* <input
                          name="fromDate"
                          type="date"
                          max={requestedToDate}
                          id="fromDate"
                          value={requestedFromDate}
                          onChange={(e) => {
                            setRequestedFromDate(e.target.value);
                            setFieldValue("fromDate", e.target.value);
                          }}
                        />
                        <p>to</p>
                        <input
                          name="toDate"
                          type="date"
                          min={requestedFromDate}
                          max={toDate.toISOString().substr(0, 10)}
                          id="toDate"
                          value={requestedToDate}
                          onChange={(e) => {
                            setRequestedToDate(e.target.value);
                            setFieldValue("toDate", e.target.value);
                          }}
                        /> */}
                      </div>
                    </SelectWrapper>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      type="app-green-button"
                      handleClick={() => {
                        callBackFun("", "", "", props.values);
                        toggle();
                      }}
                    >
                      Apply Filter
                    </Button>
                  </ModalFooter>
                </Modal>
              </Form>
            </>
          );
        }}
      </Formik>
    </div>
  );
};

const DropDownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  .dropDown {
    div {
      p {
        margin: 12px;
      }
    }
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
`;
const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  > div {
    display: flex;
    p {
      margin: 12px;
    }
  }
  .dropDown {
    width: 200px;
  }
  select,
  // input {
  //   padding: 5px;
  //   border: solid 1px transparent !important;
  //   margin: 2px 0;
  //   font-size: 16px;
  //   padding: 10px 13px 10px 13px;
  //   border-radius: 5px;
  //   background-color: #e8e2e2;
  //   -webkit-appearance: none;
  //   -moz-appearance: none;
  //   appearance: none;
  //   ::-webkit-input-placeholder {
  //     /* Edge */
  //     color: #656565;
  //   }

  //   :-ms-input-placeholder {
  //     /* Internet Explorer 10-11 */
  //     color: #656565;
  //   }

  //   ::placeholder {
  //     color: #656565;
  //   }
  // }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
  @media (max-width: 650px) {
    > div {
      flex-direction: column;
    }
  }
`;
